import axios from "axios";
import API_V2_URL from "@/constants/API_V2_URL";

const RoleService = {
  all({ page, limit, q, status, all }) {
    return axios.get(
      `${API_V2_URL()}/system/roles?page=${page}&status=${status}&limit=${limit}&q=${q}&all=${
        all ? "true" : "false"
      }`
    );
  },
  create(formData) {
    return axios.post(`${API_V2_URL()}/system/roles`, formData);
  },
  update(formData, id) {
    return axios.put(`${API_V2_URL()}/system/roles/${id}`, formData);
  }
};

export default RoleService;



// WEBPACK FOOTER //
// ./src/services/system/RoleService.js